function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, o) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = o() : "function" == typeof define && define.amd ? define(o) : t.VueProgressBar = o();
}(this, function () {
  "use strict";

  !function () {
    if ("undefined" != typeof document) {
      var t = document.head || document.getElementsByTagName("head")[0],
          o = document.createElement("style"),
          i = " .__cov-progress { opacity: 1; z-index: 999999; } ";
      o.type = "text/css", o.styleSheet ? o.styleSheet.cssText = i : o.appendChild(document.createTextNode(i)), t.appendChild(o);
    }
  }();
  var t = "undefined" != typeof window,
      r = {
    render: function render() {
      var t = this,
          o = t.$createElement;
      return (t._self._c || o)("div", {
        staticClass: "__cov-progress",
        style: t.style
      });
    },
    staticRenderFns: [],
    name: "VueProgress",
    serverCacheKey: function serverCacheKey() {
      return "Progress";
    },
    computed: {
      style: function style() {
        var t = this.progress,
            o = t.options,
            i = !!o.show,
            e = o.location,
            s = {
          "background-color": o.canSuccess ? o.color : o.failedColor,
          opacity: o.show ? 1 : 0,
          position: o.position
        };
        return "top" === e || "bottom" === e ? ("top" === e ? s.top = "0px" : s.bottom = "0px", o.inverse ? s.right = "0px" : s.left = "0px", s.width = t.percent + "%", s.height = o.thickness, s.transition = (i ? "width " + o.transition.speed + ", " : "") + "opacity " + o.transition.opacity) : "left" !== e && "right" !== e || ("left" === e ? s.left = "0px" : s.right = "0px", o.inverse ? s.top = "0px" : s.bottom = "0px", s.height = t.percent + "%", s.width = o.thickness, s.transition = (i ? "height " + o.transition.speed + ", " : "") + "opacity " + o.transition.opacity), s;
      },
      progress: function progress() {
        return t ? window.VueProgressBarEventBus.RADON_LOADING_BAR : {
          percent: 0,
          options: {
            canSuccess: !0,
            show: !1,
            color: "rgb(19, 91, 55)",
            failedColor: "red",
            thickness: "2px",
            transition: {
              speed: "0.2s",
              opacity: "0.6s",
              termination: 300
            },
            location: "top",
            autoRevert: !0,
            inverse: !1
          }
        };
      }
    }
  };
  return {
    install: function install(o) {
      var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
          i = (o.version.split(".")[0], "undefined" != typeof window),
          e = {
        $vm: null,
        state: {
          tFailColor: "",
          tColor: "",
          timer: null,
          cut: 0
        },
        init: function init(t) {
          this.$vm = t;
        },
        start: function start(t) {
          var o = this;
          this.$vm && (t || (t = 3e3), this.$vm.RADON_LOADING_BAR.percent = 0, this.$vm.RADON_LOADING_BAR.options.show = !0, this.$vm.RADON_LOADING_BAR.options.canSuccess = !0, this.state.cut = 1e4 / Math.floor(t), clearInterval(this.state.timer), this.state.timer = setInterval(function () {
            o.increase(o.state.cut * Math.random()), 95 < o.$vm.RADON_LOADING_BAR.percent && o.$vm.RADON_LOADING_BAR.options.autoFinish && o.finish();
          }, 100));
        },
        set: function set(t) {
          this.$vm.RADON_LOADING_BAR.options.show = !0, this.$vm.RADON_LOADING_BAR.options.canSuccess = !0, this.$vm.RADON_LOADING_BAR.percent = Math.floor(t);
        },
        get: function get() {
          return Math.floor(this.$vm.RADON_LOADING_BAR.percent);
        },
        increase: function increase(t) {
          this.$vm.RADON_LOADING_BAR.percent = Math.min(99, this.$vm.RADON_LOADING_BAR.percent + Math.floor(t));
        },
        decrease: function decrease(t) {
          this.$vm.RADON_LOADING_BAR.percent = this.$vm.RADON_LOADING_BAR.percent - Math.floor(t);
        },
        hide: function hide() {
          var t = this;
          clearInterval(this.state.timer), this.state.timer = null, setTimeout(function () {
            t.$vm.RADON_LOADING_BAR.options.show = !1, o.nextTick(function () {
              setTimeout(function () {
                t.$vm.RADON_LOADING_BAR.percent = 0;
              }, 100), t.$vm.RADON_LOADING_BAR.options.autoRevert && setTimeout(function () {
                t.revert();
              }, 300);
            });
          }, this.$vm.RADON_LOADING_BAR.options.transition.termination);
        },
        pause: function pause() {
          clearInterval(this.state.timer);
        },
        finish: function finish() {
          this.$vm && (this.$vm.RADON_LOADING_BAR.percent = 100, this.hide());
        },
        fail: function fail() {
          this.$vm.RADON_LOADING_BAR.options.canSuccess = !1, this.$vm.RADON_LOADING_BAR.percent = 100, this.hide();
        },
        setFailColor: function setFailColor(t) {
          this.$vm.RADON_LOADING_BAR.options.failedColor = t;
        },
        setColor: function setColor(t) {
          this.$vm.RADON_LOADING_BAR.options.color = t;
        },
        setLocation: function setLocation(t) {
          this.$vm.RADON_LOADING_BAR.options.location = t;
        },
        setTransition: function setTransition(t) {
          this.$vm.RADON_LOADING_BAR.options.transition = t;
        },
        tempFailColor: function tempFailColor(t) {
          this.state.tFailColor = this.$vm.RADON_LOADING_BAR.options.failedColor, this.$vm.RADON_LOADING_BAR.options.failedColor = t;
        },
        tempColor: function tempColor(t) {
          this.state.tColor = this.$vm.RADON_LOADING_BAR.options.color, this.$vm.RADON_LOADING_BAR.options.color = t;
        },
        tempLocation: function tempLocation(t) {
          this.state.tLocation = this.$vm.RADON_LOADING_BAR.options.location, this.$vm.RADON_LOADING_BAR.options.location = t;
        },
        tempTransition: function tempTransition(t) {
          this.state.tTransition = this.$vm.RADON_LOADING_BAR.options.transition, this.$vm.RADON_LOADING_BAR.options.transition = t;
        },
        revertColor: function revertColor() {
          this.$vm.RADON_LOADING_BAR.options.color = this.state.tColor, this.state.tColor = "";
        },
        revertFailColor: function revertFailColor() {
          this.$vm.RADON_LOADING_BAR.options.failedColor = this.state.tFailColor, this.state.tFailColor = "";
        },
        revertLocation: function revertLocation() {
          this.$vm.RADON_LOADING_BAR.options.location = this.state.tLocation, this.state.tLocation = "";
        },
        revertTransition: function revertTransition() {
          this.$vm.RADON_LOADING_BAR.options.transition = this.state.tTransition, this.state.tTransition = {};
        },
        revert: function revert() {
          this.$vm.RADON_LOADING_BAR.options.autoRevert && (this.state.tColor && this.revertColor(), this.state.tFailColor && this.revertFailColor(), this.state.tLocation && this.revertLocation(), !this.state.tTransition || void 0 === this.state.tTransition.speed && void 0 === this.state.tTransition.opacity || this.revertTransition());
        },
        parseMeta: function parseMeta(t) {
          for (var o in t.func) {
            var i = t.func[o];

            switch (i.call) {
              case "color":
                switch (i.modifier) {
                  case "set":
                    this.setColor(i.argument);
                    break;

                  case "temp":
                    this.tempColor(i.argument);
                }

                break;

              case "fail":
                switch (i.modifier) {
                  case "set":
                    this.setFailColor(i.argument);
                    break;

                  case "temp":
                    this.tempFailColor(i.argument);
                }

                break;

              case "location":
                switch (i.modifier) {
                  case "set":
                    this.setLocation(i.argument);
                    break;

                  case "temp":
                    this.tempLocation(i.argument);
                }

                break;

              case "transition":
                switch (i.modifier) {
                  case "set":
                    this.setTransition(i.argument);
                    break;

                  case "temp":
                    this.tempTransition(i.argument);
                }

            }
          }
        }
      },
          s = function (t, o) {
        for (var i, e, s = 1; s < arguments.length; ++s) {
          for (i in e = arguments[s]) {
            Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
          }
        }

        return t;
      }({
        canSuccess: !0,
        show: !1,
        color: "#73ccec",
        position: "fixed",
        failedColor: "red",
        thickness: "2px",
        transition: {
          speed: "0.2s",
          opacity: "0.6s",
          termination: 300
        },
        autoRevert: !0,
        location: "top",
        inverse: !1,
        autoFinish: !0
      }, t),
          n = new o({
        data: {
          RADON_LOADING_BAR: {
            percent: 0,
            options: s
          }
        }
      });

      i && (window.VueProgressBarEventBus = n, e.init(n)), o.component("vue-progress-bar", r), o.prototype.$Progress = e;
    }
  };
});